/* eslint-disable react/prop-types */
import React from 'react';

import ContractMap from '../../hoc/contractPage/patterns/ContractMap';

const TermsAndConditions = ({ bank }) => (
  <ContractMap page={bank.page} />
);

export default TermsAndConditions;
